import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperationsPanel = ({ selectedPlays, onBulkAction, onClearSelection }) => {
  const [selectedOperation, setSelectedOperation] = useState('');

  const operationOptions = [
    { value: '', label: 'Select bulk operation...', disabled: true },
    { value: 'export', label: 'Export selected plays' },
    { value: 'duplicate', label: 'Duplicate selected plays' },
    { value: 'archive', label: 'Archive selected plays' },
    { value: 'delete', label: 'Delete selected plays' }
  ];

  const handleExecute = () => {
    if (selectedOperation && onBulkAction) {
      onBulkAction(selectedOperation, selectedPlays);
      setSelectedOperation('');
    }
  };

  if (selectedPlays?.length === 0) return null;

  return (
    <div className="bg-accent/5 border border-accent/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name="CheckSquare" size={20} className="text-accent" />
          </div>
          <div>
            <p className="text-sm font-medium text-card-foreground">
              {selectedPlays?.length} play{selectedPlays?.length !== 1 ? 's' : ''} selected
            </p>
            <p className="text-xs text-muted-foreground">
              Choose a bulk operation to apply
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-center gap-3">
          <div className="flex-1">
            <Select
              options={operationOptions}
              value={selectedOperation}
              onChange={setSelectedOperation}
              placeholder="Select operation"
            />
          </div>
          <Button
            variant="default"
            size="sm"
            onClick={handleExecute}
            disabled={!selectedOperation}
            iconName="Play"
            iconPosition="left"
          >
            Execute
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsPanel;